<template>
  <div class="field-input-checkbox">
    <div class="input-group">
      <div class="input-group d-block mr-1 mt-1">
        <input
          type="checkbox"
          :disabled="(!!showDisabled())"
          :aria-describedby="`${fieldData.field_name}_describedby`"
          :ref="fieldData.field_name"
          :id="fieldData.field_name"
          :name="fieldData.field_name"
          v-model="fieldData.field_value"
          v-validate="field_rules"
          @change="apiRule.present && apiRule.type == 'onchange' ? postRule($event.target.value, fieldData) : ''"
          v-bind:class="{'form-check-input': true, 'mt-1': true,
            'error': errors.has(fieldData.field_name) || fieldData.has_error}">
      </div>
    </div>
  </div>
</template>

<script>
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  mixins: [inputFieldMixin],
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  components: { FieldIcon },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputCheckbox.vue?2299695e